<template>
	<section class="main-content contentblocks">
		<SectionHeader class="sectionheader" :subtitle="subtitle" :title="title" :content="content" />
		<ContentBlock v-for="(item, index) in contentblocks" :key="index" :index="index" :item="item" />
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
	content: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	title: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background-image: url('~/assets/images/contentblocks-bg.jpg');
	background-repeat: repeat-y;
	background-size: 100%;
	background-position: center;
	display: flex;
	flex-flow: column;
	gap: var(--gap);
}

.sectionheader {
	margin-bottom: var(--space-lg);
}

.background-light {
	background: var(--alternating-background-color);
}

.row-header {
	max-width: 1000px;
}

:deep(.title) {
	color: var(--color-silk);
}

:deep(.subtitle) {
	color: var(--color-pale);

	&::before,
	&:not(.no-after)::after {
		background: var(--color-pale);
	}
}

:deep(.content) {
	color: var(--color-pale);
}

@media (max-width: 1080px) {
	.main-content {
		padding: 75px 0;
	}
}

@media (max-width: 1024px) {
	.main-content {
		padding: 75px 0;
	}
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 0;
	}
}

@media (max-width: 600px) {
	.main-content {
		padding: 75px 0;
	}
}

@media (max-width: 450px) {
	.main-content {
		padding: 50px 0;
	}
}
</style>
